import url from '../../../fns/url'
import UrlParams from '../../../fns/url/params'
import mapFields from '../../../fns/object/map'
import getProp from '../../../fns/object/prop/get'
import compare from '../../../fns/compare/deep-value'

export const objLowerKeys = (data) => {
    const result = {}
    Object.entries(data).forEach(([key, value]) => {
        result[key.toLowerCase()] = value
    })
    return result
}

let otherParams = {}

const storeToUrl = {
    map: {
        engineId: 'e',
        criteria: 'c',
        country: 'country',
        region: 'region',
        domaineSki: 'domaineSki',
        department: 'department',
        station: 'station',
        parentStation: 'parentStation',
        beginDate: 'beginDate',
        endDate: 'endDate',
        capacity: 'capacity',
        priceMin: 'priceMin',
        priceMax: 'priceMax',
        surfaceMin: 'surfaceMin',
        surfaceMax: 'surfaceMax',
        packages: 'packages',
        lodgingType: 'lodgingType',
        reviewNumberMin: 'reviewsMin',
        reviewNumberMax: 'reviewsMax',
        averageRatingMin: 'avgRatingMin',
        nearbyLat: 'nearbyLat',
        nearbyLon: 'nearbyLon',
        nearbyDist: 'nearbyDist',
        liheIds: 'liheIds',
        prestIds: 'prestIds',
        rc_order: 'rc_order',
        rc_sort: 'rc_sort',
        rc_size: 'rc_size',
        rc_start: 'rc_start'
    },
    process: {}
}

const fieldNames = [
    'country',
    'region',
    'domaineSki',
    'department',
    'station',
    'parentStation',
    'beginDate',
    'endDate',
    'capacity',
    'priceMin',
    'priceMax',
    'surfaceMin',
    'surfaceMax',
    'packages',
    'lodgingType',
    'reviewNumberMin',
    'reviewNumberMax',
    'averageRatingMin',
    'nearbyLat',
    'nearbyLon',
    'nearbyDist',
    'liheIds',
    'prestIds'
]

// const testDateFormat = dateStr => {
// 	return (/^\d\d\d\d\-\d\d\-\d\d$/ig).test(dateStr);
// }
const urlToStore = {
    map: objLowerKeys({
        e: 'engineId',
        c: 'criteria',
        country: 'country',
        region: 'region',
        domaineSki: 'domaineSki',
        department: 'department',
        station: 'station',
        parentStation: 'parentStation',
        beginDate: 'beginDate',
        endDate: 'endDate',
        capacity: 'capacity',
        priceMin: 'priceMin',
        priceMax: 'priceMax',
        surfaceMin: 'surfaceMin',
        surfaceMax: 'surfaceMax',
        packages: 'packages',
        lodgingType: 'lodgingType',
        reviewsMin: 'reviewNumberMin',
        reviewsMax: 'reviewNumberMax',
        avgRatingMin: 'averageRatingMin',
        nearbyLat: 'nearbyLat',
        nearbyLon: 'nearbyLon',
        nearbyDist: 'nearbyDist',
        liheIds: 'liheIds',
        prestIds: 'prestIds',
        rc_order: 'rc_order',
        rc_sort: 'rc_sort',
        rc_size: 'rc_size',
        rc_start: 'rc_start'
    }),
    process: {
        // beginDate: value => testDateFormat(value) ? value : undefined,
        // endDate: value => testDateFormat(value) ? value : undefined,
    }
}

export const mapParams = (params, { map, process }) => {
    const result = mapFields(params, map)
    Object.entries(process).forEach(([key, fn]) => {
        fn({
            params: result,
            initial: params,
            value: result[key]
        })
    })
    return result
}

const getUrlState = ({ query, hash, urlToStore }) => {
    const stateQueryOld = urlToStore.old ? mapParams(query, urlToStore.old) : {}
    const stateHashOld = urlToStore.old ? mapParams(hash, urlToStore.old) : {}

    const stateQuery = mapParams(
        {
            ...query, // might contain old formatted values
            ...objLowerKeys(stateQueryOld) // old format mapped to new format
        },
        urlToStore
    )
    const stateHash = mapParams(
        {
            ...hash,
            ...objLowerKeys(stateHashOld)
        },
        urlToStore
    )

    const state = {
        ...stateQuery,
        ...stateHash
    }

    return state
}

export const getOtherParams = (params, seParams) => {
    const result = {}
    const seParamsMap = {}
    seParams.forEach((param) => {
        seParamsMap[param.toLowerCase()] = true
    })
    Object.entries(params).forEach(([key, value]) => {
        if (!seParamsMap[key.toLowerCase()]) {
            result[key] = value
        }
    })
    return result
}

const getFieldNames = () => {
    return fieldNames
}

let urlState = {}

const initUrl = ({ instance }) => {
    const updateUrlWithStore = () => {
        const hashStr = getUrlStrFromStoreWithOtherParams() // URI encoded
        const hash = url.getHash()
        if (hash === hashStr) {
            return
        }
        onHashChange.ignore()
        const paramsLowerToClear = getParamsLowerToClear()
        if (paramsLowerToClear.length > 0) {
            const cleanedQueryParams = cleanQueryParams(paramsLowerToClear)
            const queryStr = UrlParams.generate(cleanedQueryParams)
            const urlStr = `${window.location.pathname}${queryStr ? `?${queryStr}` : ''}${hashStr ? `#${hashStr}` : ''}`
            url.setUrl(urlStr)
        } else {
            url.setHash(hashStr)
        }
    }

    const getParamsLowerToClear = () => {
        const { queryLower } = UrlParams.get(window.location.href)
        const paramsLowerToClear = [
            ...Object.keys(urlToStore.old ? urlToStore.old.map : {}).filter((c) => queryLower.hasOwnProperty(c)),
            ...Object.keys(urlToStore.map).filter((c) => queryLower.hasOwnProperty(c))
        ]
        return paramsLowerToClear
    }
    const cleanQueryParams = (paramsLowerToClear) => {
        const { query } = UrlParams.get(window.location.href)
        const paramsToKeep = Object.entries(query).reduce((params, [key, value]) => {
            if (!paramsLowerToClear.includes(key.toLowerCase())) {
                params[key] = value
            }
            return params
        }, {})
        return paramsToKeep
    }
    // removeEndDate hotfix for train project, not my idea

    const getUrlStrFromStoreWithOtherParams = () => {
        const state = getStoreStateForUrl(removeEndDate)
        const urlStr = getUrlStrForState(state)
        return urlStr
    }

    const getUrlStrForState = (state) => {
        const urlStr = UrlParams.generate({
            ...state,
            ...otherParams.hash
        })
        return urlStr
    }

    const getUrlStrFromStore = (removeEndDate = false) => {
        const state = getStoreStateForUrl(removeEndDate)
        const urlStr = UrlParams.generate(state)
        return urlStr
    }

    // removeEndDate hotfix for train project, not my idea
    const getStoreStateForUrl = (removeEndDate = false) => {
        const state = getStoreState()
        const mappedState = mapParams(state, storeToUrl)

        if(removeEndDate) {
            delete mappedState.endDate
        }
        
        return mappedState
    }

    const getStoreState = () => {
        const store = instance.store
        const fields = getFieldNames()
        const state = {
            criteria: store.getSelectedCriterias()
        }
        const engineId = store.getEngineId()
        if (engineId) {
            state.engineId = engineId
        }
        fields.forEach((field) => {
            const value = store.getFieldValue(field)
            if (value) {
                state[field] = value
            }
        })
        const sort = store.getSort()
        if (sort.type && sort.direction) {
            state.rc_order = sort.type
            state.rc_sort = sort.direction
        }
        const page = store.getPage()
        if (page) {
            state.rc_start = (parseInt(page) + 1).toString()
        }
        const resultsPerPage = store.getResultsPerPage()
        if (resultsPerPage) {
            state.rc_size = resultsPerPage
        }

        return state
    }

    const updateStoreWithUrl = (state) => {
        const fields = getFieldNames()

        onStoreUpdate.ignore()
        instance.store.batch(() => {
            instance.store.addCriterias(state.criteria || [])
            instance.store.setEngineId(state.engineId)
            fields.forEach((field) => {
                if (!state.hasOwnProperty(field)) {
                    return
                }
                const value = state[field]
                if (Array.isArray(value)) {
                    value.forEach((id) => instance.store.addFieldValue(field, id))
                } else {
                    instance.store.setFieldValue(field, value)
                }
            })
            if (state.rc_order && state.rc_sort) {
                instance.store.setSort({
                    type: state.rc_order,
                    direction: state.rc_sort
                })
            }
            if (state.rc_start) {
                instance.store.setPage((parseInt(state.rc_start) - 1).toString())
            }
            if (state.rc_size) {
                instance.store.setResultsPerPage(state.rc_size)
            }
        })
    }

    const prepareOtherParams = () => {
        const { queryLower, hashLower } = UrlParams.get(window.location.href)

        const seParams = [
            // old params
            ...Object.keys(getProp(urlToStore.old ? urlToStore.old.map : {})),
            // actual params
            ...Object.keys(urlToStore.map)
        ].map((param) => param.toLowerCase())

        // otherParams.query = getOtherParams(queryLower, seParams);
        otherParams.hash = getOtherParams(hashLower, seParams)
    }

    const setOldUrlsMapper = ({ map = {}, process = {} }) => {
        urlToStore.old = {
            map: objLowerKeys(map),
            process
        }
    }
    const setUrlToStoreMapper = ({ map, process }) => {
        if (map) urlToStore.map = map // objLowerKeys(map);
        if (process) urlToStore.process = process
    }
    const setStoreToUrlMapper = ({ map, process }) => {
        if (map) storeToUrl.map = map // objLowerKeys(map);
        if (process) storeToUrl.process = process
    }
    const extendUrlToStoreMapper = ({ map, process }) => {
        if (map) {
            urlToStore.map = {
                ...urlToStore.map,
                ...map
            }
        }
        if (process) {
            urlToStore.process = {
                ...urlToStore.process,
                ...process
            }
        }
    }
    const extendStoreToUrlMapper = ({ map, process }) => {
        if (map) {
            storeToUrl.map = {
                ...storeToUrl.map,
                ...map
            }
        }
        if (process) {
            storeToUrl.process = {
                ...storeToUrl.process,
                ...process
            }
        }
    }
    const urlMapperIgnoreParams = (params) => {
        params.forEach((param) => {
            urlToStore.map[param] = undefined
            storeToUrl.map[param] = undefined
        })
    }

    const getCurrentUrlState = () => {
        const { queryLower, hashLower } = UrlParams.get(window.location.href)
        return getUrlState({
            query: queryLower,
            hash: hashLower,
            urlToStore
        })
    }

    const onStoreUpdate = instance.store.on(instance.store.events.REQUEST, () => {
        if (syncState) {
            prepareOtherParams()
            updateUrlWithStore()
            urlState = getCurrentUrlState()
        }
    })
    const onHashChange = url.on(url.events.HASH, () => {
        if (syncState) {
            const newUrlState = getCurrentUrlState()
            if (compare(urlState, newUrlState)) {
                return
            }
            instance.store.batch(() => {
                instance.store.clearRequest()
                updateStoreWithUrl(newUrlState)
            })
            urlState = newUrlState
        }
    })

    const restore = () => {
        urlState = getCurrentUrlState()
        updateStoreWithUrl(urlState)
    }

    let syncState = false
    // let preparedOtherParams = false;
    const sync = (_syncState) => {
        syncState = _syncState
        // if(!preparedOtherParams){
        // prepareOtherParams();
        // preparedOtherParams = true;
        // }
    }

    return {
        restore,
        sync,
        getUrl: getUrlStrFromStore,
        setOldUrlsMapper,
        setUrlToStoreMapper,
        setStoreToUrlMapper,
        extendUrlToStoreMapper,
        extendStoreToUrlMapper,
        urlMapperIgnoreParams,
        getStoreState
    }
}

const preInitUrl = (instance) => {
    return {
        init: () => initUrl({ instance })
    }
}

export default preInitUrl
